/* eslint-disable */
import './lib/jquery-3.4.1.min.js';
import '../scss/popup.scss';
import './base/icon.font.js';

/**
* Import Components
*/

import InitPopup from './components/popup.js';

/**
* Init - initalises all project classes
*/
class Init{

	constructor(){
		//Base Initialisers
		if(document.domain.indexOf("mq.edu.au") >= 0)
			document.domain = "mq.edu.au"
		new InitPopup();
		
		
	}

}
new Init();
